import {useCallback, useMemo} from 'react';

import {observer} from 'mobx-react-lite';

import type {GetComponentProps} from '../../../../utils/utility-types';
import type {Props} from './types';

import {ProgramInvitesListItemJSX} from '../../components/ProgramInvitesListItem';
import {ProgramInviteModel} from './model';

export const ProgramInvitesListItem = observer<Props>(
  ({
    invite,
    onCancelButtonClick,
    onMoreIconClick,
    onResendButtonClick,
    ...rest
  }) => {
    const model = useMemo(() => new ProgramInviteModel(invite), [invite]);

    const onMoreIconClickCb: GetComponentProps<
      typeof ProgramInvitesListItemJSX
    >['onMoreIconClick'] = useCallback(
      e => {
        e.event.DOMEvent?.stopPropagation?.();

        onMoreIconClick?.(e, invite);
      },
      [invite, onMoreIconClick],
    );

    const onCancelButtonClickCb: GetComponentProps<
      typeof ProgramInvitesListItemJSX
    >['onCancelButtonClick'] = useCallback(
      e => {
        e.event.DOMEvent?.stopPropagation?.();

        onCancelButtonClick?.(e, invite);
      },
      [invite, onCancelButtonClick],
    );

    const onResendButtonClickCb: GetComponentProps<
      typeof ProgramInvitesListItemJSX
    >['onResendButtonClick'] = useCallback(
      e => {
        e.event.DOMEvent?.stopPropagation?.();

        onResendButtonClick?.(e, invite);
      },
      [invite, onResendButtonClick],
    );

    return (
      <ProgramInvitesListItemJSX
        avatar={model.avatar}
        courseLabel={model.courseLabel}
        initialEmail={model.initialEmail}
        isInviteByEmail={model.isInviteByEmail}
        label={model.label}
        message={model.message}
        name={model.name}
        onCancelButtonClick={onCancelButtonClickCb}
        onMoreIconClick={onMoreIconClickCb}
        onResendButtonClick={onResendButtonClickCb}
        {...rest}
      />
    );
  },
);
